<div class="nav-logo">
    <img class="w-100 mt-2 mb-2" src="/assets/images/Logo-01.png" alt="">
</div>
<perfect-scrollbar class="side-nav-content">
    <vertical-menu-content></vertical-menu-content>
</perfect-scrollbar>